import { FencyContentStatus } from "../../autogen/bff-api";

export const parseFencyContentStatus = (data: unknown): FencyContentStatus | null => {
  let parsed: { contentStatus?: string };
  if (typeof data === "string") {
    try {
      parsed = JSON.parse(data) as { contentStatus?: string };
    } catch {
      return null;
    }
  } else if (data && typeof data === "object" && "contentStatus" in data) {
    parsed = data as { contentStatus?: string };
  } else {
    return null;
  }
  const status = parsed?.contentStatus;
  if (status && Object.values(FencyContentStatus).includes(status as FencyContentStatus)) {
    return status as FencyContentStatus;
  }
  return null;
};
